module.exports = __webpack_public_path__ + "static/media/searching.a494ba8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/searching.svg
// module id = 545
// module chunks = 0